import { __awaiter } from "tslib";
import Vue from 'vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
import { RESPONSE_STATUS_CODES } from '@/constants/serverConstants';
import { StepByStepGlossary } from '@/constants/services';
import stepByStepValidate from '@/services/_helpers/stepByStepValidate';
var Modes;
(function (Modes) {
    Modes["edit"] = "edit";
    Modes["exclusion"] = "exclusion";
})(Modes || (Modes = {}));
const networksRules = {};
function tryFindNetwork(address) {
    const matchesArray = Object.entries(networksRules).reduce((arr, curr) => {
        const [key, value] = curr;
        if (value(address))
            arr.push(key);
        return arr;
    }, []);
    if (matchesArray.length) {
        return matchesArray.length === 1
            ? 'TRX'
            : 'BSC';
    }
    else
        return false;
}
let savedWalletSecret = '';
export default Vue.extend({
    name: 'WhitelistsResolveNetworksPage',
    data: () => ({
        mode: Modes.edit,
        form: {
            fields: {
                listOfValid: [],
                listOfInvalid: [],
                doubles: {}
            }
        },
        availableNetworks: [],
        loading: false
    }),
    computed: {
        letSave() {
            return this.form.fields.listOfValid.every((item) => {
                if (!item.selected)
                    return true;
                return item.network !== this.$t('whitelistsPage.chooseNetwork');
            });
        },
        letSaveDoubles() {
            return Object.values(this.form.fields.doubles).every((item) => item.selected.key > -1);
        },
        computedBackLink() {
            if (this.$route.query.isFromTransfersPage) {
                return { name: 'transfersPage', query: { isRebuild: true } };
            }
            return { name: 'whitelists' };
        }
    },
    filters: {
        parseAvailableNetworks(value, address) {
            return value.map((item) => ({
                key: item.key,
                value: item.label,
                isActive: networksRules[item.key](address)
            }));
        }
    },
    methods: {
        handleClickLeaveLink() {
            const vm = this;
            this.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: false,
                title: `Редактирование ${vm.$route.query.id ? 'кошелька ' + vm.$options.filters.fixString(vm.$route.query.name, 20) : 'кошельков'}`,
                content: '',
                slot: {
                    name: 'leaveWhitelistsEditingConfirmPopupChunk'
                },
                actions: [
                    {
                        title: 'Уйти со страницы',
                        isAccent: false,
                        callback() {
                            vm.$store.commit('popupModule/setClosed');
                            vm.$router.replace(vm.computedBackLink);
                        }
                    },
                    {
                        title: 'Остаться',
                        isAccent: true,
                        callback() { vm.$store.commit('popupModule/setClosed'); }
                    }
                ]
            });
        },
        init() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                this.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: false,
                    title: `Редактирование ${vm.$route.query.id ? 'кошелька ' + vm.$options.filters.fixString(vm.$route.query.name, 20) : 'кошельков'}`,
                    content: '',
                    slot: {
                        name: 'confirmSecretCodeToResolveNetworksPopupChunk',
                        data: {
                            name: vm.$route.query.name,
                            isLoading: false
                        },
                        on: {
                            onConfirm(walletSecret) {
                                return __awaiter(this, void 0, void 0, function* () {
                                    vm.$store.commit('popupModule/setSlotData', { isLoading: true });
                                    const response = yield vm.services.mainService.getWhitelistWalletsWithAddresses({
                                        walletSecret,
                                        identify: true
                                    }, vm.$route.query.id);
                                    if (response.success) {
                                        savedWalletSecret = walletSecret;
                                        vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                                        vm.$store.commit('popupModule/setClosed');
                                        vm.availableNetworks = response.data.networks;
                                        response.data.networks.forEach((item) => {
                                            networksRules[item.key] = (v) => {
                                                const reg = new RegExp(item.rule);
                                                return reg.test(v);
                                            };
                                        });
                                        const listOfValid = [];
                                        const listOfInvalid = [];
                                        for (const item of response.data.wallets) {
                                            item.selected = true;
                                            if (item.isValidAddress) {
                                                if (!item.network) {
                                                    item.network = tryFindNetwork(item.address) || 'Выбрать сеть';
                                                }
                                                else {
                                                    const findedNetworkItem = vm.availableNetworks.find((network) => network.label.toLowerCase() === item.network.toLowerCase());
                                                    item.network = findedNetworkItem.key;
                                                }
                                                listOfValid.push(item);
                                            }
                                            else {
                                                item.toDelete = false;
                                                listOfInvalid.push(item);
                                            }
                                        }
                                        vm.form.fields.listOfValid = listOfValid;
                                        vm.form.fields.listOfInvalid = listOfInvalid;
                                    }
                                    else {
                                        vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                                        vm.$store.dispatch('alertsBus/openAlert', {
                                            title: vm.$t('whitelistsPage.alerts.titles.error'),
                                            type: 'error',
                                            autoDelete: true,
                                            content: vm.$t('whitelistsPage.alerts.content.invalidKey')
                                        });
                                    }
                                });
                            },
                            onCancel() {
                                vm.$router.push(vm.computedBackLink);
                            }
                        }
                    },
                    actions: []
                });
            });
        },
        setSsid() {
            return __awaiter(this, void 0, void 0, function* () {
                const sessionResponse = yield this.services.mainService.confirmSession({ sessionId: StepByStepGlossary.doTransfer });
                if (sessionResponse.success) {
                    const response = yield stepByStepValidate({
                        name: StepByStepGlossary.doTransfer,
                        endpointName: StepByStepGlossary.validateSession,
                        data: {
                            sessionId: sessionResponse.data.session_id,
                            payload: { wallet_secret: savedWalletSecret }
                        },
                        steps: 3
                    });
                    if (response.success) {
                        localStorage.setItem('withdrawSSID', JSON.stringify(sessionResponse.data));
                    }
                }
            });
        },
        handleSave() {
            return __awaiter(this, void 0, void 0, function* () {
                this.loading = true;
                const listToDelete = this.form.fields.listOfInvalid.filter((item) => item.toDelete).map((item) => item.id);
                if (listToDelete.length) {
                    yield this.services.mainService.deleteWhitelistWallet({
                        walletSecret: savedWalletSecret,
                        ids: listToDelete
                    });
                }
                const listToChange = this.form.fields.listOfValid.filter((item) => item.selected).map((item) => ({
                    network: item.network,
                    id: item.id
                }));
                if (listToChange.length) {
                    const changeResponse = yield this.services.mainService.changeWhitelistsNetworks({
                        walletSecret: savedWalletSecret,
                        wallets: listToChange
                    });
                    if (changeResponse.success) {
                        if (changeResponse.status === RESPONSE_STATUS_CODES.ACCEPTED) {
                            this.mode = Modes.exclusion;
                            this.form.fields.doubles = Object.entries(changeResponse.data).reduce((arr, curr) => {
                                const [key, val] = curr;
                                if (Object.keys(val).length) {
                                    arr[Object.keys(val)[0]] = {
                                        network: key,
                                        walletsNames: val[Object.keys(val)[0]]
                                    };
                                }
                                return arr;
                            }, {});
                            for (const doubleName of Object.keys(this.form.fields.doubles)) {
                                this.$set(this.form.fields.doubles[doubleName], 'selected', {
                                    key: -1,
                                    value: this.$t('whitelistsPage.chooseWallet')
                                });
                            }
                        }
                        else {
                            if (this.$route.query.isFromTransfersPage) {
                                yield this.setSsid();
                            }
                            this.$router.push(this.computedBackLink);
                        }
                    }
                }
                else
                    this.$router.push(this.computedBackLink);
                this.loading = false;
            });
        },
        handleSaveDoubles() {
            return __awaiter(this, void 0, void 0, function* () {
                this.loading = true;
                const listToDelete = Object.values(this.form.fields.doubles).reduce((arr, curr) => {
                    for (const wallet of curr.walletsNames) {
                        if (wallet.key !== curr.selected.key) {
                            arr.push(wallet.key);
                        }
                    }
                    return arr;
                }, []);
                if (listToDelete.length) {
                    yield this.services.mainService.deleteWhitelistWallet({
                        walletSecret: savedWalletSecret,
                        ids: listToDelete
                    });
                }
                const listToChange = [];
                for (const [key, value] of Object.entries(this.form.fields.doubles)) {
                    listToChange.push({
                        network: value.network,
                        id: value.selected.key
                    });
                }
                if (listToChange.length) {
                    const changeResponse = yield this.services.mainService.changeWhitelistsNetworks({
                        walletSecret: savedWalletSecret,
                        wallets: listToChange,
                        forceUpdate: true
                    });
                    if (changeResponse.success) {
                        if (changeResponse.status === RESPONSE_STATUS_CODES.ACCEPTED) {
                            this.mode = Modes.exclusion;
                            this.form.fields.doubles = Object.entries(changeResponse.data).reduce((arr, curr) => {
                                const [key, val] = curr;
                                val.walletsNames = val.walletsNames.map((item) => ({
                                    key: item.id,
                                    value: item.name
                                }));
                                arr[key] = val;
                                return arr;
                            }, {});
                            for (const doubleName of Object.keys(this.form.fields.doubles)) {
                                this.$set(this.form.fields.doubles[doubleName], 'selected', {
                                    key: -1,
                                    value: this.$t('whitelistsPage.chooseWallet')
                                });
                            }
                        }
                        else {
                            if (this.$route.query.isFromTransfersPage) {
                                yield this.setSsid();
                            }
                            this.$router.push(this.computedBackLink);
                        }
                    }
                }
                else
                    this.$router.push(this.computedBackLink);
                this.loading = false;
            });
        }
    },
    created() {
        this.init();
    }
});
